// extracted by mini-css-extract-plugin
export default {"container":"BlackWrapper_container__6bx7J"};